module.exports = __webpack_public_path__ + "img/caminhao-verde.f0608049.png";